import './error-assistant'
import '@weblite/ts-action/types'
import { createContext } from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { FileProvider } from '@weblite/file'
import { AudioProvider } from '@weblite/audio'
import './internationalization'
import './persist.ts'
import { ErrorBoundary } from '$helper/components/error-boundary'
import store from './redux'
import { WappRunnerProvider } from './wapp-runner'
import { ThemeProvider } from './material-theme'
import { Root as PanelsRoot } from '../scenes/root'
import '$scenes/router-panels/router-config'
import '../logic/main/root.subscribe.js'
import '../hooks/after/installPwa'
import './multiTab'
import '../hooks/on/blur&Focus'
import '../hooks/on/windowResize'
import '../hooks/on/wappCommunication'
import '../hooks/on/loadTwa'
import '../hooks/before/installprompt'
import './file'
import './analytics'
import './notification/notification'
import '$comp/modals/modal.registration'
import './reportingObserver'
import './workbox'
import './emoji'
import './visual-viewport'
import './profiler'
import './style/global.scss'
import { addSWLogGetterToWindow } from './sw-log'
import '$helper/functions/no-sleep'

export const DirectionContext = createContext('rtl')

addSWLogGetterToWindow()

// TODO: redux provide and store to react-redux file
export default () => {
  return (
    <ReduxProvider store={store}>
      <ErrorBoundary>
        <ThemeProvider>
          <WappRunnerProvider>
            <FileProvider>
              <AudioProvider>
                <PanelsRoot />
              </AudioProvider>
            </FileProvider>
          </WappRunnerProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </ReduxProvider>
  )
}
